import React, {useEffect} from 'react'
import {Route, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import AdminLayout from 'layouts/Admin'
import Swal from 'sweetalert2'
import jwtDecode from 'jwt-decode'
const  AdminRoute = ({component:Component, authenticated, admin, authChecked, loading, ...rest}) => {

    useEffect(() => {
        if (!authChecked || loading) {
            Swal.fire({
                title: 'Loading...',
                text: 'Please wait while loading',
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        } else {
            Swal.close();
        }
    }, [authChecked, loading]);

    return (
        <Route {...rest}
            render = {(props) => {
                if (!authChecked || loading) {
                    return null;
                }

                // Check if token is actually valid
                const token = localStorage.getItem('FBIdToken');
                let tokenValid = false;
                if (token) {
                    try {
                        const decoded = jwtDecode(token);
                        tokenValid = decoded.exp * 1000 > Date.now();
                    } catch (e) {
                        tokenValid = false;
                    }
                }

                if (authenticated === true && tokenValid){
                    if (admin === true ){

                        return <AdminLayout><Component {...props}/></AdminLayout>
                    } else {

                        return <Redirect to = "/client/question-bank/create-test"/>
                    }
                } else {
                    return <Redirect to = "/auth/login"/>
                }
            }
            }
        />
)}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading
})

export default connect(mapStateToProps)(AdminRoute)
